import React, { useEffect } from 'react'
import { BrowserRouter,Routes, Route, Navigate  } from 'react-router-dom'
import Login from './components/Login';
import MoveLink from "./components/MoveLink";
import { MoveUserPool, ViewUserPool } from './userpool';
import './App.css';
import ViewLink from "./components/ViewLink";
import FastLink from "./components/FastLink";


function App() {

  useEffect(()=>{
      if(MoveUserPool.getCurrentUser()) {
        <Navigate to="/link" replace />
      }
      else if(ViewUserPool.getCurrentUser()) {
        <Navigate to="/view" replace />
      }
  },[]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Login />}/>
        <Route path='/login' element={<Login />}/>
        <Route path="/link" element={<MoveLink/>}/>
        <Route path="/move" element={<MoveLink/>}/>
        <Route path="/view" element={<ViewLink/>}/>
        <Route path="/fast" element={<FastLink/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
